/** Render seguro de HTML de presentación (builders del módulo). */
export default function HtmlBlock({ html, onClick, className }) {
  return (
    <div
      className={className || undefined}
      dangerouslySetInnerHTML={{ __html: html || '' }}
      onClick={onClick}
    />
  );
}
